import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface CustomQuanityBreakPricingByProductNumber {
    fetchingFromAPI: boolean;
    qtyBreakPricingByProductNumber: {
        [key: string]: PriceBreaks[];
    };
}

export interface CustomQuanityBreakPricing {
    productNumber: string;
    priceBreaks: PriceBreaks[];
}

export interface PriceBreaks {
    from: number;
    to: number;
    price: number;
}

const initialState: CustomQuanityBreakPricingByProductNumber = {
    fetchingFromAPI: false,
    qtyBreakPricingByProductNumber: {},
};

const reducer = createTypedReducerWithImmer(initialState, {
    "CustomQuantityBreakPricing/StartFetching": (draft: Draft<CustomQuanityBreakPricingByProductNumber>) => {
        draft.fetchingFromAPI = true;
    },
    "CustomQuantityBreakPricing/Update": (
        draft: Draft<CustomQuanityBreakPricingByProductNumber>,
        action: { payload: CustomQuanityBreakPricing },
    ) => {
        draft.qtyBreakPricingByProductNumber[action.payload.productNumber] = action.payload.priceBreaks;
    },
    "CustomQuantityBreakPricing/CompleteFetching": (draft: Draft<CustomQuanityBreakPricingByProductNumber>) => {
        draft.fetchingFromAPI = false;
    },
});

(reducers as any).customQuantityBreakPricing = reducer;

export type CustomCustomQuantityBreakPricingState = {
    customQuantityBreakPricing: CustomQuanityBreakPricingByProductNumber;
} & ApplicationState;

type Reducers = {
    customQuantityBreakPricingReducer: typeof reducer;
};

export type CustomQuantityBreakPricingActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
